import PropTypes from 'prop-types';
import React, { Component } from 'react';

class PercentageBarsWrapper extends Component {
    static propTypes = {
        isLoading: PropTypes.bool
    };

    static defaultProps = {
        isLoading: true
    };

    render() {
        return (
            <div className='percentage-bars'>
                {this.props.isLoading ? <div className='inline-spinner'></div> : this.props.children}
            </div>
        )
    }
}

export default PercentageBarsWrapper;



// WEBPACK FOOTER //
// ./src/scripts/reusable/PercentageBars/PercentageBarsWrapper.jsx